module.exports = __webpack_public_path__ + "img/sprite.adf585dc.svg";